export default __webpack_public_path__ + "static/media/FontAwesome.04080e6c.png";